import { omit } from 'lodash/fp';
import { apiRequest } from '@/core';
import {
  type EditEventPayload,
  type SetCurrentEventPayload,
} from '@/slices/events/types';

export const editEventRequest = async (event: EditEventPayload) =>
  apiRequest<SetCurrentEventPayload>({
    endpoint: `api/events/${event.id}`,
    method: 'PUT',
    body: omit('property_id', event),
  });
